export default "__VITE_ASSET__DGSRvK3b__"